import classNames from "classnames"
import { PackageCard } from "./PackageCard"
import styles from './style.module.less';
import { Plan, getPlans } from "@/services/checkout.service"
import { useRequest } from "ahooks"
import { getCurrentPlan } from "@/services/subscription/subscription.service"
import { useMemo, useState } from "react"
import { groupBy } from "lodash"
import { Radio, Spin } from "antd"

const tabs = ['General Access', 'Process Engineer', 'Drafter']

export const Pricing = () => {
  const {data = [], loading: plansLoading} = useRequest(() => getPlans())
  const {data: myPlanInfo, loading: myPlanLoading} = useRequest(getCurrentPlan)
  const {subscription: myPlan} = myPlanInfo || {}

  const [tab, setTab] = useState('General Access')

  const groups = useMemo(() => {
    if (!data) return {}
    const group = groupBy(data, 'category')
    Object.keys(group).forEach((cardKey) => {
      const cards = group[cardKey] || []
      cards.sort((a, b) => a.billingFrequency === 'year' ? 1 : -1)
    })
    return group
  }, [data])

  const cards = groups[tab] || []

  if (plansLoading || myPlanLoading) {
    return <div className="p-4 flex-center"><Spin /></div>
  }
  
  return <div className={styles.pageContainer}>
    <div className={styles.pricingHeader}>
      <h3 className={styles.headText}>Choose your plan</h3>
    </div>
    <div className="flex-center">
      <Radio.Group value={tab} onChange={(evt) => setTab(evt.target.value)}>
        {tabs.map((name) => {
          return <Radio.Button value={name}>{name}</Radio.Button>
        })}
      </Radio.Group>
    </div>
    <div className={classNames('flex flex-center mt-2', styles.cards)}>
      
      {
        cards.map(item => {
          return <PackageCard
            key={item.type}
            plan={item}
            myPlan={myPlan}
          />
        })
      }
    </div>
  </div>
}